import Raven from 'raven-js';
let hasReported = false;
export function reportMissingScopes({
  state,
  // These defaulted internal arguments make testing much cleaner
  _location = (_window => (_window = window) === null || _window === void 0 ? void 0 : _window.location)(),
  _hasReported = hasReported
}) {
  if (_hasReported) {
    return;
  }
  hasReported = true;
  console.warn(`Onboarding Scopes: No Scopes present in state, this will cause unexpected behaviour in identifying Hubs.
    Is this hook used within a Redux context? Does the Redux context store scopes at 'auth.user.scopes'?`, {
    state
  });
  try {
    if (Raven.isSetup()) {
      var _state$auth, _location$pathname;
      Raven.captureMessage('onboarding-scopes: useScopes called without scopes available via `auth.user.scopes` in Redux state', {
        level: 'error',
        extra: {
          hasAuth: Boolean(state.auth),
          hasUser: Boolean((_state$auth = state.auth) === null || _state$auth === void 0 ? void 0 : _state$auth.user),
          stateProperties: Object.keys(state),
          pathname: (_location$pathname = _location === null || _location === void 0 ? void 0 : _location.pathname) !== null && _location$pathname !== void 0 ? _location$pathname : 'unknown'
        }
      });
    }
  } catch (_unused) {
    // Silent — console.warn already fired above
  }
}